import React, {useState} from 'react';
import {Tabs} from 'antd';
import ShoppingRoad from './ShoppingRoad';
import ShoppingRoadEventGroup from './ShoppingRoadEventGroup';
import ShoppingRoadManager from './ShoppingRoadManager';

const ShoppingRoadIndex = () => {
    const [activeKey, setActiveKey] = useState('shoppingRoad');

    const items = [
        {
            key: 'shoppingRoad',
            label: '쇼핑 로드 관리',
            children: <ShoppingRoad/>,
        },
        {
            key: 'manager',
            label: '쇼핑 로드 매니저',
            children: <ShoppingRoadManager/>,
        },
        {
            key: 'eventGroup',
            label: '쇼핑 로드 이벤트 그룹',
            children: <ShoppingRoadEventGroup/>,
        }
    ];

    return (
        <Tabs
            activeKey={activeKey}
            onChange={setActiveKey}
            items={items}
        />
    );
};

export default ShoppingRoadIndex;